{
  "fr": {
    "inspiration_list": {
      "actions": {
        "cancel": "Annuler",
        "delete": "Supprimer",
        "deleteMultiple": "Supprimer...",
        "delete_cancel": "Annuler",
        "edit": "Modifier",
        "new": "Album d'inspiration",
        "save": "Enregistrer",
        "submit": "Enregistrer",
        "tickBoxesDeletion": "Sélectionnez les listes d'inspiration que vous souhaitez supprimer."
      },
      "attributes": {
        "name": "Nom"
      },
      "info": "Qu'est-ce que vous aimez pour votre nouvelle maison? Téléchargez des photos qui vous inspirent! Les albums vous permettent de les organiser en différents thèmes: cuisine, salle de bain, mobilier, ...",
      "labels": {
        "inspiration_list": "Albums d'inspiration",
        "inspirationlist": "Album d'Inspiration",
        "inspirations": "Inspirations",
        "noInspirationLists": "Aucun album d'inspiration pour le moment",
        "noInspirations": "Pas encore d'inspiration"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Créez différents albums pour votre cuisine, votre salle de bain ou vos meubles et téléchargez des photos qui vous inspirent.",
            "title": "Comment allez-vous décorer votre nouvelle maison?"
          }
        }
      },
      "validation": {
        "needTitle": "Champ requis",
        "selectInspirationList": "Sélectionnez au moins 1 album d'inspiration"
      }
    }
  }
}